module.exports = __webpack_public_path__ + "img/star-christmas.ebc5e270.svg";